import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "track-action-icon-create-case",
  "use": "track-action-icon-create-case-usage",
  "viewBox": "0 0 36 36",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 36 36\" id=\"track-action-icon-create-case\">\n    <path fill=\"#3F65FF\" d=\"M32 18.5v-6c0-1.375-1.125-2.5-2.5-2.5H24V7.5c0-.828-.672-1.5-1.5-1.5h-9c-.828 0-1.5.672-1.5 1.5V10H6.5C5.125 10 4 11.125 4 12.5v6h28zM22 10h-8V8h8v2zm7.5 20c1.375 0 2.5-1.125 2.5-2.5V20H21.5v2.5c0 .547-.453 1-1 1h-5c-.547 0-1-.453-1-1V20H4v7.5C4 28.875 5.125 30 6.5 30h23zM20 22v-2h-4v2h4z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol